module.exports = __webpack_public_path__ + "media/npc_dota_hero_witch_doctor.11a4fc8a.webm";